import "./QuoteExpiryField.css";

import { ProjectIssuanceTransactionConstants } from "../../../../constants";
import { DatePicker, KanaTooltip, ReadonlyText } from "../../../../widget";

export interface QuoteExpiryFieldProps {
  transactionType: string | null;
  value?: Date;
  onChange: (date: Date | undefined) => void;
  tooltipText?: string;
  disabled?: boolean;
  isOverdue?: boolean;
  variant?: "hub" | "seed";
}

export const QuoteExpiryField = ({
  transactionType,
  value,
  onChange,
  tooltipText = "The date this quote expires.",
  disabled = false,
  isOverdue = false,
  variant = "seed",
}: QuoteExpiryFieldProps): JSX.Element | null => {
  if (transactionType !== ProjectIssuanceTransactionConstants.ISSUANCE_TRANSACTION_TYPE_QUOTE) return null;

  const tooltip = <KanaTooltip tooltipHeader="Expiry date" tooltipText={tooltipText} />;

  return (
    <div className="QuoteExpiryField">
      {disabled ? (
        <ReadonlyText
          label="Expiry date"
          value={value ? value.toLocaleDateString("en-GB") : undefined}
          tooltipHeader="Expiry date"
          tooltipText={tooltipText}
          noDataAvailable={!value}
        />
      ) : (
        <DatePicker
          label="Expiry date"
          value={value}
          onChange={onChange}
          tooltip={tooltip}
          hasError={isOverdue}
          corners={variant === "seed" ? "rounded" : "default"}
          font={variant === "seed" ? "figtree" : "default"}
        />
      )}
      {isOverdue && <p className="body2 QuoteExpiryField_Overdue">This quote has expired.</p>}
    </div>
  );
};
